import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { withTranslate } from '../../../core/TenantProvider';
import APClientDetailsSectionStyles from './styles/APClientDetailsSection.style';
import APMultiSelect from '../../atoms/APMultiSelect';
import APHeading from '../../atoms/APHeading';
import { APCheckbox } from '../../atoms/APInput';
import APLabel from '../../atoms/APLabel';
import { FormControlLabel, FormGroup } from '@mui/material';
import { GoogleAnalyticTags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../../core/utils/GoogleAnalyticTag';
import {
    setSelectedIndustries, setSelectedClientLanguages,
    setSelectedCountries
} from '../../../containers/SettingsContainer/utils/setters';
import { InitialSettingValues } from '../../../containers/SettingsContainer/SettingsContainer';

interface APClientDetailsSectionProps extends WithStyles<typeof APClientDetailsSectionStyles> {
    translate: Function,
    values: InitialSettingValues | undefined,
    handleChange: Function,
    isSuperUser?: boolean
}

class APClientDetailsSection extends Component<APClientDetailsSectionProps> {

    clientType = {
        personal: 'settings.client.personalclient.label',
        onlineMarketplaceSellers: 'settings.client.onlinemarketplace.label',
        corporate: 'settings.client.corporateclient.label'
    }

    render() {
        const {
            classes,
            translate,
            values,
            handleChange,
            isSuperUser = false
        } = this.props;

        const {
            whichIndustriesYouOperate,
            whichCountriesAreYourClientsBasedIn,
            languages,
            whichClientsDoYouService } = GoogleAnalyticTags.settings.select;
        const {
            whichIndustriesYouOperate: whichIndustriesYouOperateGA4,
            whichCountriesAreYourClientsBasedIn: whichCountriesAreYourClientsBasedInGA4,
            languages: languagesGA4,
            whichClientsDoYouService: whichClientsDoYouServiceGA4 } = GoogleAnalytics4Tags.settings.select;

        const handleMultiSelectChange = (
            event: React.ChangeEvent<any>,
            valueSetter: Function | null,
            googleAnalyticsEventAction: string,
            googleAnalytics4EventAction: string,
            clientType: string | null = null,
            selectedValueType: string = '') => {

            let selectedValue: string | null;

            if (valueSetter !== null) {
                event.target.value = valueSetter(event.target.value);
                selectedValue = event.target.value.toString().split(',').pop();
            } else {
                selectedValue = clientType;
            }

            TriggerGoogleAnalyticsTag(
                GoogleAnalyticTags.eventAction.select,
                googleAnalyticsEventAction,
                { [selectedValueType]: selectedValue }
            );
            TriggerGoogleAnalytics4Tag(
                GoogleAnalytics4Tags.settings.name,
                GoogleAnalytics4Tags.eventAction.select,
                googleAnalytics4EventAction,
                { [selectedValueType]: selectedValue }
            );

            handleChange(event);
        };

        return (
            <>
                <div className={classes.settingsFormSection}>
                    <div className={classes.formSectionHeader}>
                        <APHeading className={classes.formSectionHeading}
                            variant="body1">
                            {translate('settings.client.details.heading')}
                        </APHeading>
                    </div>
                    <div className={classes.formSectionContent}>
                        <APLabel>{translate('settings.client.operatingindustries.label')}</APLabel>
                        <FormGroup
                            className={classes.formSectionCheckbox}>
                            <ul>
                                {Object.entries(this.clientType).map(([clientType, label]) => (
                                    <li key={clientType}>
                                        <FormControlLabel
                                            value={values?.clientTypes?.[clientType]}
                                            control={<APCheckbox />}
                                            onChange={(event) => {
                                                handleMultiSelectChange(
                                                    event,
                                                    null,
                                                    whichClientsDoYouService,
                                                    whichClientsDoYouServiceGA4,
                                                    clientType,
                                                    'clients')
                                            }}
                                            name={`clientTypes.${clientType}`}
                                            label={translate(label)}
                                        />
                                    </li>
                                ))}
                            </ul>
                        </FormGroup>
                    </div>
                </div>
                <div className={classes.settingsFormSection}>
                    <div className={classes.formSectionContent}>
                        <APMultiSelect className={classes.manualInput}
                            label={translate('settings.client.selectindustries.label')}
                            name="selectedIndustries"
                            onChange={(event: React.ChangeEvent<any>) => {
                                handleMultiSelectChange(
                                    event,
                                    setSelectedIndustries,
                                    whichIndustriesYouOperate,
                                    whichIndustriesYouOperateGA4,
                                    null,
                                    'industry')
                            }}
                            type="industry"
                            selectedValues={values?.selectedIndustries}
                            value={values?.selectedIndustries}
                            disabled={isSuperUser}
                        />
                        <APMultiSelect className={classes.manualInput}
                            label={translate('settings.client.selectcountries.label')}
                            name="selectedCountries"
                            onChange={(event: React.ChangeEvent<any>) => {
                                handleMultiSelectChange(
                                    event,
                                    setSelectedCountries,
                                    whichCountriesAreYourClientsBasedIn,
                                    whichCountriesAreYourClientsBasedInGA4,
                                    null,
                                    'countries')
                            }}
                            type="country"
                            selectedValues={values?.selectedCountries}
                            value={values?.selectedCountries}
                            disabled={isSuperUser}
                        />
                        <APMultiSelect className={classes.manualInput}
                            label={translate('settings.client.selectlanguages.label')}
                            name="selectedClientLanguages"
                            onChange={(event: React.ChangeEvent<any>) => {
                                handleMultiSelectChange(
                                    event,
                                    setSelectedClientLanguages,
                                    languages,
                                    languagesGA4,
                                    null,
                                    'languages')
                            }}
                            selectedValues={values?.selectedClientLanguages}
                            type="language"
                            value={values?.selectedClientLanguages}
                            disabled={isSuperUser}
                        />
                    </div>
                </div>
            </>
        )
    }
}

export default withTranslate(
    withStyles(APClientDetailsSectionStyles)(APClientDetailsSection)
);